import React, { FC, Fragment } from "react";
import { useSelector } from "react-redux";
import { UserRole } from "@/Contracts/Users";
import { GlobalState } from "@/Reducers/interface";
import { checkUseRoleDisplay } from "@/Hooks/utils";

interface Props {
	readonly requiredRole: UserRole;
}

export const useRoleDisplay = (requiredRole?: UserRole) => {
	const userRole = useSelector(
		(state: GlobalState) => state.user.userData?.role
	);
	return checkUseRoleDisplay(userRole)(requiredRole);
};

const RoleBasedDisplayWrapper: FC<Props> = props => {
	const isUserInRole = useRoleDisplay(props.requiredRole);
	return isUserInRole ? <Fragment>{props.children}</Fragment> : null;
};

export default RoleBasedDisplayWrapper;
